// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"538":"recorder","983":"profiler"}[chunkId] + "." + {"538":"46a9cdc4f6a0676a","983":"5e87204b05847611"}[chunkId] + ".js";
};